import { IIndicatorData } from "./iindicator-data-strategy";
import { IndicatorData } from "./indicator-data";

export class TopTenNetworksIndicatorData implements IIndicatorData {
  private readonly name: string = "TopTenNetworks";

  constructor(private readonly items: IndicatorData[]) {}

  public getName(): string {
    return this.name;
  }

  public getItems() {
    return this.items.map((item) => {
      const networkNameIdicatorData = item.getValue()[0] as IndicatorData;
      const networkName = networkNameIdicatorData.getValue();

      const networkDistricIdicatorData = item.getValue()[1] as IndicatorData;
      const networkDistric = networkDistricIdicatorData.getValue();

      const networkBalanceIdicatorData = item.getValue()[2] as IndicatorData;
      const networkBalance = networkBalanceIdicatorData.getValue();

      return {
        networkFiscalNumber: item.getKey(),
        networkName,
        networkDistric,
        networkBalance,
      };
    });
  }
}
